import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const OrderReviewDesktopSectionSkeleton: React.FC = () => {
  return (
    <SkeletonTheme
      borderRadius={'5rem'}
      baseColor="#E1E8EF"
      duration={2.0}
      highlightColor="#FEFEFE"
    >
      <div className="flex flex-col gap-[1.6rem] border-b-[0.1rem] border-b-[#CBD5E1] py-[1.6rem]">
        <Skeleton height="2rem" width={'24.2rem'} />
        {[...Array(2)].map((_, index) => (
          <div key={index} className="flex gap-[1.6rem]">
            <Skeleton
              height="1.4rem"
              containerClassName="flex-[24.2rem] max-w-[24.2rem]"
            />
            <Skeleton height="1.4rem" containerClassName="flex-1" />
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

export default OrderReviewDesktopSectionSkeleton;
